var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 433,
    height: 188,
    viewBox: "0 0 433 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.622 187.601C216.622 187.601 171.461 127.893 92.3716 119.821L139.167 43.9682L178.699 47.1998V37.9377C178.699 37.9377 150.432 32.6769 129.48 29.4326L61.6748 135.959C61.6748 135.959 174.641 134.344 216.622 187.601Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195.631 182.741C195.631 182.741 127.839 131.118 29.4004 156.939L76.2025 74.6362H90.6795L98.8148 60.1069H67.5011L0.357422 177.919C0.357422 177.919 103.63 139.185 195.631 182.741Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M189.156 32.6768V139.293C189.156 139.293 205.293 147.257 211.749 160.164V32.6768H189.156Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.272 64.9734V115.088C155.272 115.088 171.41 118.205 177.859 127.893V64.9734H155.272Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M216.622 187.601C216.622 187.601 261.783 127.893 340.878 119.821L294.044 43.9682L254.512 47.1998V37.9377C254.512 37.9377 282.773 32.6769 303.763 29.4326L371.505 135.959C371.505 135.959 258.545 134.344 216.622 187.601Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M237.567 182.741C237.567 182.741 305.341 131.099 403.779 156.92L356.977 74.6362H342.525L334.39 60.1069H365.678L432.822 177.919C432.822 177.919 329.55 139.185 237.567 182.741Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M244.023 0.399414V139.293C244.023 139.293 227.886 147.257 221.43 160.164V0.399414H244.023Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M277.907 89.1589V115.088C277.907 115.088 261.77 118.205 255.32 127.893V89.1589H277.907Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccMark);
export default __webpack_public_path__ + "static/media/acc_mark.5627421295dbb26270cd4437bd42b437.svg";
export { ForwardRef as ReactComponent };